/* components/AccordionBody.ts

Accordion Body Component
sets the body height for when the accordion is open so animation is nice
*/

import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionBody extends ThemeComponent {
    @Prop({ default: 36 }) paddingBottom!: number;

    init() {
        window.onload = () => {
            const height = this.scrollHeight;
            this.style.height = height + this.paddingBottom + 'px';
        };
    }
}
